/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface MaybeWrapInDivSignature {
  Args: {
    wrap?: boolean;
    classNames?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}
export default class MaybeWrapInDiv extends Component<MaybeWrapInDivSignature> {
  get wrap() {
    return this.args.wrap ?? false;
  }
}
